import { Stack, TextField, InputAdornment, Button } from '@mui/material';
import Iconify from 'src/components/iconify';

type Props = { filters: { name: string }; onFilters: (name: string, value: any) => void; canReset: boolean; onResetFilters: VoidFunction };

export default function AccountTableToolbar({ filters, onFilters, canReset, onResetFilters }: Props) {
  return (
    <Stack direction="row" alignItems="center" spacing={2} sx={{ p: 2.5 }}>
      <TextField
        fullWidth
        value={filters.name}
        onChange={(e) => onFilters('name', e.target.value)}
        placeholder="Tìm kiếm tài khoản, email..."
        InputProps={{
          startAdornment: <InputAdornment position="start"><Iconify icon="eva:search-fill" /></InputAdornment>,
        }}
      />
      {canReset && <Button color="error" onClick={onResetFilters} startIcon={<Iconify icon="solar:trash-bin-trash-bold" />}>Clear</Button>}
    </Stack>
  );
}